import React, { useState } from 'react';
import Header from './components/Header';
import Problem from './components/Problem';
import Score from './components/Score';
import Feedback from './components/Feedback';
import 'bulma/css/bulma.min.css';
import './App.css';


const App = () => {

    const [problemNumber, setProblemNumber] = useState(1);
    const [problemsCorrect, setProblemsCorrect] = useState(0);

    return(
        <div className="main">
            <Header />
            <Problem 
                problemNumber = {problemNumber}
                setProblemNumber = {setProblemNumber}
                problemsCorrect = {problemsCorrect}
                setProblemsCorrect = {setProblemsCorrect}
            />
            <Score 
                problemNumber = {problemNumber}
                problemsCorrect = {problemsCorrect}
            />
            <Feedback />
        </div>
    );

}

export default App;